import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import Product from '../components/Product';
import { LinearProgress } from "@mui/material";
import ProductsFile from '../components/Products.json';

function Merch() {

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        document.title = "Merch - Lehumo"

        /*
        const fetchProducts = async () => {
            setIsLoading(true);
            const response = await axios.get(ProductsFile);
            setProducts(response.data);
            setIsLoading(false);
        };

        fetchProducts();
    }, []);

    */

        const fetchProducts = async () => {
            setIsLoading(true);
            const response = ProductsFile;
            setProducts(response);
            setIsLoading(false);
        };

        fetchProducts();

    }, []);


    return (
        <>
            <Container>

                <h1>Get Awesome Merch</h1>
                <h5>When you buy our merch you help to fund our development process</h5>

                {!isLoading ? (

                    <Content>
                        <>
                            {products.map(product => {
                                return (
                                    <Product
                                        key={product.id}
                                        product_name={product.name}
                                        product_size={product.size}
                                        product_image={product.image}
                                        product_image_hover={product.hover_image}
                                        price={product.price}
                                        product_url={product.url}
                                        tag_message={product.tag_message}
                                        buttonText={product.button_text}
                                    />
                                );
                            })}
                        </>
                    </Content>
                ) : (
                    <div><LinearProgress style={{ backgroundColor: "var(--primary)" }} /></div>
                )}
            </Container>
        </>
    )

}

export default Merch

const Container = styled.div`
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 100px 0;

    h1 {
        text-transform: uppercase;
        text-align: center;
        font-size: 36px;
        padding: 10px 0;
    }

    h5 {
        text-transform: uppercase;
        text-align: center;
        font-size: 13px;
        color: #333;
        font-weight: 200;
    }

`

const Content = styled.div`
    width: 95%;
    margin: 0 auto;
    padding-top: 40px;
    text-align: center;
    display: grid;
    grid-gap: 200px;
    align-items: center;
    justify-content: space-evenly;
    grid-template-columns: repeat(4, minmax(0,1fr));

    
    /* Mobile Phone */

    @media (max-width: 600px) {
        grid-template-columns: repeat(2, minmax(0,1fr));
        grid-gap: 10px;
    }

    /* iPads or Tablets */

    @media (min-width: 760px) {
        grid-template-columns: repeat(3, minmax(0,1fr));
    }

    /* Nest Hub & Nest Hub Max */

    @media (min-width: 1000px) {
        grid-template-columns: repeat(3, minmax(0,1fr));
    }

    /* Laptops & Desktops */

    @media (min-width: 1300px) {
        grid-template-columns: repeat(5, minmax(0,1fr));
    }
`

